import { render, staticRenderFns } from "./MerchantAdd.vue?vue&type=template&id=4736533e&"
import script from "./MerchantAdd.vue?vue&type=script&lang=js&"
export * from "./MerchantAdd.vue?vue&type=script&lang=js&"
import style0 from "./MerchantAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports